module.exports = __webpack_public_path__ + "img/floor-wulian.78f4a171.png";